<div class="prayers-page-container">
    <h2 class="page-header">
        <div>Prayers/Chants</div>
        <span></span>
    </h2>
</div>